import React from 'react';
import CreatedLoadFunctional from './components/create-load-list-functional';

const CreatedLoad = () => {
	return <CreatedLoadFunctional />;
};

export default CreatedLoad;
